const webDomain = location.protocol + '//' + location.host;
const Is_SignIn_URL = webDomain + '/app/shopv3/new';
const SFORM_HTTP_URL = webDomain + '/app/shopv3/config';
const REPORT_HTTP_URL = webDomain + '/app/shopv3/report';
const DAMIAO_HTTPS_URL = 'https://tp.hd.mi.com';
const VERIFY_URL = webDomain + '/app/shopv3/captcha';
const STAT_HTTP_URL = webDomain + '/app/stat/visitv2';
const LOGIN_URL = __DEV__
  ? 'https://m.youpin.mi.com/app/shop/login'
  : `${location.protocol}//${location.host}/app/shop/login`;
const ACTIVITY_URL = webDomain + '/nu';

// var HELP_HTTP_URL = webDomain + '/api/helpcenter/index';
const HELP_HTTP_URL = webDomain + '/help/center';

// var UPDATE_LOGIN_URL = `${webDomain}/api/auth/login/loggedin`;
const UPDATE_LOGIN_URL = `${webDomain}/api/auth/login/isloggedin`;

// var YingKeBao_URL = `${webDomain}/api/yingkebao/resource/get`;

// __publicPath为webpack注入
const IMG_BASE_URL = __DEV__ ? '' : __publicPath; // + '/mijia-m/yrn-buz-shop-center';

const SHOPAPI_GATEWAY_URL = webDomain + '/mtop/navi';

export {
  Is_SignIn_URL,
  SFORM_HTTP_URL,
  DAMIAO_HTTPS_URL,
  REPORT_HTTP_URL,
  VERIFY_URL,
  STAT_HTTP_URL,
  LOGIN_URL,
  ACTIVITY_URL,
  UPDATE_LOGIN_URL,
  IMG_BASE_URL,
  // YingKeBao_URL,
  HELP_HTTP_URL,
  SHOPAPI_GATEWAY_URL,
};
